import { TFunction } from "i18next"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import {
  ContactSalutationType,
  ContactSalutationValues,
  ContactType,
  ContactTypeValues,
} from "@aviv-ipp/bff-types"

const contactTypeLabels: Record<ContactType, string> = {
  SELL: "contactAgency_projectTypesSell",
  BUY: "contactAgency_projectTypesBuy",
  RENT: "contactAgency_projectTypesRent",
  MANAGE: "contactAgency_projectTypesManage",
  ASK_A_QUESTION: "contactAgency_projectTypesQuestion",
}

const contactSalutationLabels: Record<ContactSalutationType, string> = {
  MR: "salutation_MR",
  MRS: "salutation_MRS",
  DIVERS: "salutation_DIVERS",
  NONE: "",
}

const contactTypePlaceholders: Record<ContactType, string> = {
  SELL: "contactAgency_messagePlaceholderSell",
  BUY: "contactAgency_messagePlaceholderBuy",
  RENT: "contactAgency_messagePlaceholderRent",
  MANAGE: "contactAgency_messagePlaceholderManage",
  ASK_A_QUESTION: "contactAgency_messagePlaceholderQuestion",
}

export const makeDropdownContactTypeItems = (t: TFunction) =>
  ContactTypeValues.map((type) => ({
    id: type,
    label: t(contactTypeLabels[type]),
  }))

export const makeDropdownContactSalutationItems = (t: TFunction) =>
  ContactSalutationValues.filter((type) => type !== "NONE").map((type) => ({
    id: type,
    label: t(contactSalutationLabels[type]),
  }))

export const useConstants = (isGermanBrand?: boolean) => {
  const { t } = useTranslation()
  return {
    contactTypePlaceholders,
    dropdownContactTypeItems: useMemo(
      () =>
        isGermanBrand
          ? makeDropdownContactTypeItems(t).filter((item) => item.id !== "ASK_A_QUESTION")
          : makeDropdownContactTypeItems(t),
      [t, contactTypeLabels]
    ),
    dropdownContactSalutationItems: useMemo(
      () => makeDropdownContactSalutationItems(t),
      [t, contactSalutationLabels]
    ),
  }
}
